const SET_PARENT_PLATFORM = 'src/parentPlatform/SET_PARENT_PLATFORM' as const;
const SET_ALL_PARENT_PLATFORMS = 'src/parentPlatform/SET_ALL_PARENT_PLATFORMS' as const;
const REQUEST_PARENT_PLATFORMS = 'src/parentPlatform/REQUEST_PARENT_PLATFORMS' as const;

export default {
  SET_PARENT_PLATFORM,
  SET_ALL_PARENT_PLATFORMS,
  REQUEST_PARENT_PLATFORMS
};
